import classNames from 'classnames';
import React from 'react';

import { BaseLinkPanelText } from '../LinkPanelTypes';

type Props = {
    id: string;
    prefixClass?: string;
    className?: string;
} & BaseLinkPanelText;

const TextContent: React.FC<Props> = ({
    id,
    prefixClass = 'sgw-link-panel',
    title,
    textOne,
    textTwo,
    textThree,
    className,
}) => (
    <span className={classNames(`${prefixClass}__content-wrapper`, className)}>
        <span id={id} className={`${prefixClass}-title title`}>
            {title}
        </span>
        {textOne && <span className={`${prefixClass}-sub-text-one sub-text-one`}>{textOne}</span>}
        {(textTwo || textThree) && (
            <div className={`${prefixClass}__second-line second-line`}>
                {textTwo && <span className={`${prefixClass}-sub-text-two sub-text-two`}>{textTwo}</span>}
                {textThree && <span className={`${prefixClass}-sub-text-three sub-text-three`}>{textThree}</span>}
            </div>
        )}
    </span>
);

export default TextContent;
